import styled, { css } from "styled-components";

export const CheckboxGroup = styled.div`
  margin: 0 0 20px;
`;
